export enum LoadType {
    FCL = 'fcl',
    LCL = 'lcl',
    FTL = 'ftl',
    LTL = 'ltl'
}
